import React, { Component } from 'react';
import { Input } from 'reactstrap';
import { api_url } from "../globalFunction/global_string";

export class SelectNet extends Component {
  static displayName = SelectNet.name;

  constructor(props) {
    super(props);
    this.state = {
      id: props.id,
      name: props.name,
      requiredAPI: props.requiredAPI,
      options: [],
      current_user_type : localStorage.getItem('login_user_type'),
      local_net_id : localStorage.getItem('login_user_net_id'),
      selectedNet: props.selectedNet, // 將selectedUrl設置為狀態
    };
  }

  loadData() {
    let apiUrl = api_url + this.state.requiredAPI;
    let {parentName} = this.props;
    const formData = new FormData();
    if (parentName === 'Excel') {
      formData.append("current_user_type", localStorage.getItem('login_user_type'));
      formData.append("local_net_id", localStorage.getItem('login_user_net_id'));
      formData.append("local_unit_id", localStorage.getItem('login_user_unit_id'));
    } 
    else if (parentName === 'Statistical') {
      formData.append("current_user_type", localStorage.getItem('login_user_type'));
      formData.append("local_net_id", this.state.local_net_id);
      formData.append("local_unit_id", this.state.local_unit_id);
    }else if (parentName === 'superS'){
      formData.append("current_user_type", localStorage.getItem('login_user_type'));
      formData.append("local_net_id", localStorage.getItem('login_user_net_id'));
      formData.append("local_unit_id", localStorage.getItem('login_user_unit_id'));
    }

    fetch(apiUrl, {
      method: "POST",
      headers: { "Authorization": localStorage.getItem('accessToken') },
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        let arr_status = [String(data.statusCode), data.row, data.detail]; //api 回傳判斷
        const rows = Array.isArray(arr_status[1]) ? arr_status[1] : [arr_status[1]];
        this.setState({ options: rows },()=>{
        });
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }

  componentDidMount() {
    let apiUrl = api_url + this.state.requiredAPI;
    
    const formData = new FormData();
    formData.append("current_user_type", this.state.current_user_type);
    formData.append("local_net_id", this.state.local_net_id);
    
    fetch(apiUrl,{
      method: "POST",
      headers: { "Authorization": localStorage.getItem('accessToken') },
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        // console.log("componentDidMount.data",data)
        let arr_status = [String(data.statusCode), data.row, data.detail] //api 回傳判斷
        // console.log("componentDidMount.data",arr_status,arr_status[1])
        const rows = Array.isArray(arr_status[1]) ? arr_status[1] : [arr_status[1]];
        this.setState({ options : rows },()=>{
          // console.log("componentDidMount",this.state.options)
        });
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }

  handleSelectChange = (event) => {
    const { name, value } = event.target;
    const selectedIndex = event.target.selectedIndex;
    const selectedName = event.target.options[selectedIndex].text;
  
    this.props.handleNetSelectChange({ name, value, selectedName });
  };
  render() {
    if (this.state.options.length === 0) {
      return <div>Loading...</div>; // 或其他載入中提示
    }
    return (
      <Input 
      id={this.state.id} 
      name={this.state.name} 
      onChange={this.handleSelectChange} 
      type='select'
      value={this.props.selectedNet} // 使用 prop 設置選擇的值
      >
          <option key="0" value="">
            請選擇
          </option>
        {this.state.options.map(option => (
          <option key={option.local_net_id} value={option.local_net_id}>
            {option.local_net_name}
          </option>
      ))}
      </Input>
    );
  }
}